type TListener = () => void;

/**
 * useSyncExternalStore 的辅助函数，用 Set 来维护更新监听，提供 subscribe 和 notify 方法。
 *
 * @param getSnapshot - 一个函数，用于获取当前的数据快照
 * @returns 一个对象，包含 subscribe、notify 和 getSnapshot 方法
 */
export function createUseSyncExternalStore<T>(getSnapshot: () => T) {
  const listeners = new Set<TListener>();
  const subscribe = (listener: TListener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const notify = () => {
    listeners.forEach((listener) => listener());
  };

  return { subscribe, notify, getSnapshot };
}
